import React from 'react';
import ProjectcsBanner from '../components/projects/ProjectcsBanner';
import ProjectsPortolio from '../components/projects/ProjectsPortolio';

const OurProject = () => {
  return (
    <React.Fragment>
      <ProjectcsBanner />
      <div className="blur-effect"></div>
      <ProjectsPortolio />
    </React.Fragment>
  );
};

export default OurProject;
